import { gql } from "gql";

export const GET_COMPANY_DOCUMENT_READ_CONFIRMATION_TYPE = gql(/* GraphQL */ `
  query GetCompanyDocumentReadConfirmationType($id: ID!) {
    getCompanyDocumentById(id: $id) {
      id
      ...CompanyDocumentReadConfirmationType
    }
  }
`);
